export const ORGANIZATION_NAME = 'airBaltic'
export const ORGANIZATION_LEGAL_NAME = 'Air Baltic Corporation AS'
export const ORGANIZATION_IATA_CODE = 'BT'
export const ORGANIZATION_FOUNDING_DATE = '1995'
